import React from "react";
import LiveContent from "../../components/Right/LiveContent";


import { Users } from "../../DummyData";

const Live = () => {
  return (
    <>
      {Users.map((u) => (
        <LiveContent key={u.id} user={u} />
      ))}
    </>
  );
};

export default Live;
